import React from "react";
import styled from "@emotion/styled";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const MissionProgressText = styled.div`
  font-size: ${props => (props.isPage ? "48px" : "20px")};
  color: ${props => (props.isPage ? "black" : "white")};
  font-weight: bold;
`;

const MissionColor = styled.div`
  background: ${props => props.color};
  font-weight: bold;
  padding: 4px 8px;
  font-size: 16px;
`;

export default function MissionProgress({
  isPage = false,
  missions,
  completedMissions,
  braceletColor,
  braceletName,
}) {
  const percentage = (completedMissions / missions) * 100;

  return (
    <CircularProgressbarWithChildren
      value={percentage}
      background={isPage}
      strokeWidth={16}
      styles={buildStyles({
        strokeLinecap: "butt",
        pathColor: braceletColor,
        trailColor: "#C4C4C4",
        backgroundColor: "#ffffff",
      })}
    >
      <MissionProgressText isPage={isPage}>
        {`${completedMissions} / ${missions}`}
      </MissionProgressText>
      {isPage && (
        <MissionColor color={braceletColor}>{braceletName}</MissionColor>
      )}
    </CircularProgressbarWithChildren>
  );
}
